export default "__VITE_ASSET__Bz4lIxb3__"